<template>
  <img :key="company" :src="miniature" alt="nr" class="field nr" />
</template>

<script setup>
import { appStore } from "@/store";
import { computed } from "vue";

const company = computed(() => appStore.state.companies.m_company);
const miniature = require(`./../assets/miniaturas/empresas/${company.value}.png`);
</script>

<style scoped>
.field {
  position: absolute;
  font-size: 12pt;
  color: #000;
  z-index: 1;
}
.field.nr {
  top: 4mm;
  left: 50mm;
  width: 13%;
  height: 18%;
}
</style>
